module.exports = __webpack_public_path__ + "static/img/4.f66855d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/3/1/sp/4.png
// module id = xejz
// module chunks = 0